// extracted by mini-css-extract-plugin
export default {"Create":"Create_Create__hbJ7I","form":"Create_form__IKWvq","answer-check":"Create_answer-check__lUd5l"};